import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=44c49994&scoped=true&"
var script = {}
import style0 from "@/assets/scss/login.scss?vue&type=style&index=0&id=44c49994&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c49994",
  null
  
)

export default component.exports